import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  Router, NavigationStart, NavigationEnd, NavigationError,
  NavigationCancel, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute
} from '@angular/router';
import { UtilitesService } from '@systemic/services';

@Component({
  selector: 'body',
  templateUrl: './main.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit {
  title = 'app';
  // tslint:disable-next-line:max-line-length
  globalBodyClass = 'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

  constructor(private lib: UtilitesService, private _router: Router) { }

  ngOnInit() {
    this._router.events.subscribe(route => {
      if (route instanceof NavigationStart) {
        this.lib.script.setLoading(true);
        this.lib.script.bodyClass(this.globalBodyClass);
      }
      if (route instanceof NavigationEnd) {
        this.lib.script.setLoading(false);
      }
      if (route instanceof NavigationError) {
        this.lib.script.setLoading(false);
      }
      if (route instanceof NavigationCancel) {
        this.lib.script.setLoading(false);
      }
    });
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/main.component.ts